"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contentUpsertSchema = exports.pageContentSchema = void 0;
const zod_1 = require("zod");
// Full DB row schema — mirrors Prisma PageContent model exactly.
// Note: the adminList endpoint returns a namespace summary (page, label, group, locales)
// rather than raw DB rows; getEntry returns { page, locale, data }. Both are typed as
// PageContent for simplicity — consuming components already cast to their specific shapes.
// The `data` Json column holds Record<string, string> content per the content registry.
exports.pageContentSchema = zod_1.z.object({
    id: zod_1.z.string(),
    page: zod_1.z.string(),
    locale: zod_1.z.string(),
    label: zod_1.z.string(),
    data: zod_1.z.unknown(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
// API verbatim schema (source of truth: apps/api/src/common/schemas.ts)
// Admin content editor: only the fields of one namespace (string -> string).
// The page/locale URL parameter provides context; only `data` is carried in the body.
exports.contentUpsertSchema = zod_1.z.object({
    data: zod_1.z.record(zod_1.z.string(), zod_1.z.string()),
});
//# sourceMappingURL=page-content.js.map